import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient) { }

  public getRequest(path: string){
    return new Promise((resolve)=>{
      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('x-api-key', 'gYc1kOxleZ5mlL8Pn4JSD2BpnfeNN4r88Arp5Dsa');
      this.http.get(environment.apiUrl+path,{
        headers: headers
      })
      .subscribe((res)=>resolve({error: null, res: res}),(err: any)=>resolve({error: err.error.message}))
    })
  }

  public postRequest(path: string, params: any = {}){
    return new Promise((resolve)=>{
      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('x-api-key', 'gYc1kOxleZ5mlL8Pn4JSD2BpnfeNN4r88Arp5Dsa');
      this.http.post(environment.apiUrl+path, params,{
        headers: headers
      })
      .subscribe((res)=>resolve({error: null, res: res}),(err: any)=>resolve({error: err.error.message}))
    })
  }

}
